import { render, staticRenderFns } from "./delete-custom-lut.vue?vue&type=template&id=4e6c1e6e&"
import script from "./delete-custom-lut.vue?vue&type=script&lang=js&"
export * from "./delete-custom-lut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports